(function() {
  function swapDiamonds() {
    if (!window.jbDiamondSvg) return;
    // Variant picker swatch buttons + facet swatches labelled Diamond
    var targets = document.querySelectorAll(
      '.swatch-button[aria-label*="iamond"] img, ' +
      'button[aria-label*="iamond"] .swatch, ' +
      'label[aria-label*="iamond"] img'
    );
    targets.forEach(function(el) {
      if (el.dataset.jbDiamond) return;
      el.dataset.jbDiamond = '1';
      if (el.tagName === 'IMG') {
        el.src = window.jbDiamondSvg;
        el.srcset = '';
        el.style.objectFit = 'contain';
        el.style.padding = '15%';
        el.style.background = '#fff';
      } else {
        el.style.setProperty('--swatch--background', 'url(' + window.jbDiamondSvg + ')');
        el.style.backgroundImage = 'url(' + window.jbDiamondSvg + ')';
        el.style.backgroundSize = '70%';
        el.style.backgroundRepeat = 'no-repeat';
        el.style.backgroundPosition = 'center';
        el.style.backgroundColor = '#fff';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapDiamonds);
  } else {
    swapDiamonds();
  }
  new MutationObserver(swapDiamonds).observe(document.documentElement, { childList: true, subtree: true });
})();
